export default "__VITE_ASSET__CMI17jrm__"